module.exports = __webpack_public_path__ + "static/media/CircuralInactiveLight.b67d2fc1.svg";